import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../../components-new/ui/Modal';
import ContactAvatar from '../../../../../components-new/general/ContactAvatar';
import Translate from '../../../../../components/Translate';
import config from "../../../../../config";
import ColorIndicator from "../../../../../components-new/general/ColorIndicator";
import {generalModalStyles} from "../../../../../utils/General";
import SilverButton from "../../../../../components-new/buttons/SilverButton";
import BlueButton from "../../../../../components-new/buttons/BlueButton";
import Colors from "../../../../../utils/Colors";
import MenuIcon from "../../../../../assets/icons/MenuIcon";
import ForwardIcon from "../../../../../assets/icons/ForwardIcon";
import SilentModeSwitch from "./SilentModeSwitch";
import './ChatActionModals.css';

const dialogStyles = {
    list: {
        width: '100%',
        maxHeight: '300px',
        overflow: 'auto',
        cursor: 'pointer'
    },
    listItemWrapper2: {
        padding: '10px',
    },
    selectedListItem2: {
        padding: '10px',
        borderRadius: '10px',
        backgroundColor: Colors.blueExtraLite,
    },
    listItem: {
        maxWidth: '380px',
        marginLeft: '10px',
        fontSize: '16px',
    }
};

const ForwardDialogModal = ({state, close, contactClick, contactList, user, conv}) => {
    const [selectedId, setSelectedId] = useState(null);
    const [silentMode, setSilentMode] = useState(false);

    const handleContact = (contact) => {
        setSelectedId(contact.id);
    };

    const handleUnmanagedListClick = () => {
        setSelectedId("-1");
    }

    const handleSelection = () => {
        if (selectedId === "-1") {
            contactClick("-1", silentMode, conv);
            close();
            return
        }
        let found = contactList.find(contact => contact.id === selectedId);
        if (selectedId === user.id) {
            found = user
        }
        contactClick(found, silentMode, conv);
        close()
    };

    const handleInputChange = (event) => {
        setSilentMode(event)
    };

    return (
        <Modal closeTimeoutMS={config.closeTimeoutMS}
               style={generalModalStyles.convHeaderModalStyles}
               isOpen={state.isOpen}
               onRequestClose={close}
               title={<Translate text="forward"/>}
               description={<Translate text="forwardInfo"/>}
               headerIcon={<ForwardIcon width={20} height={20} stroke="var(--ds-fg-secondary)"/>}
               headerSeparator
               footerSeparator
               footer={<React.Fragment>
                   <SilverButton type="button" width="auto" height="40px" onClick={close}>
                       <Translate text="close"/>
                   </SilverButton>
                   <BlueButton type="button" width="auto" height="40px"
                               disabled={selectedId === undefined || selectedId === null}
                               onClick={handleSelection}>
                       <Translate text="forward"/>
                   </BlueButton>
               </React.Fragment>}>

            <div className="chat-action-modal__body">
            <ul style={dialogStyles.list} className="list chat-action-modal__selection-list">
                <li
                    className="forward-list-item"
                    key={'-1'}
                    style={'-1' === selectedId ? dialogStyles.selectedListItem2 : dialogStyles.listItemWrapper2}
                    onClick={() => handleUnmanagedListClick()}
                >
                    <button
                        type="button"
                        className="no-style-button centered-flex-container"
                        style={{padding: '0'}}
                    >
                        <MenuIcon width={30} height={30} style={{color: Colors.blueDark}} stroke="currentColor"/>
                        <span
                            className="hide-text-overflow"
                            style={{
                                ...dialogStyles.listItem,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '15px',
                                marginLeft: '21px'
                            }}
                        >
                            <Translate text={'unmanagedList'}/>
                        </span>
                    </button>
                </li>

                <li
                    className="forward-list-item"
                    key={user.id}
                    style={user.id === selectedId ? dialogStyles.selectedListItem2 : dialogStyles.listItemWrapper2}
                    onClick={() => handleContact(user)}
                >
                    <button
                        type="button"
                        className="no-style-button centered-flex-container"
                        style={{padding: '0'}}
                    >
                        <ContactAvatar contact={user} variant="menu"/>
                        <span
                            className="hide-text-overflow"
                            style={{
                                ...dialogStyles.listItem,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '15px',
                                marginLeft: '21px'
                            }}
                        >
                            {`${user.firstName} ${user.lastName}`} (<Translate text={'you'}/>)
                        </span>
                    </button>
                </li>

                {contactList && contactList.filter(c => c.currentStatus === config.currentStatusMap.available).map((contact) => {
                    const firstName = contact.firstName ? contact.firstName : '';
                    const lastName = contact.lastName ? contact.lastName : '';
                    return (
                        <li
                            className="forward-list-item"
                            key={contact.id}
                            style={contact.id === selectedId ? dialogStyles.selectedListItem2 : dialogStyles.listItemWrapper2}
                            onClick={() => handleContact(contact)}
                        >
                            <button
                                type="button"
                                className="no-style-button centered-flex-container"
                                style={{padding: '0'}}
                            >
                                <ContactAvatar contact={contact} variant="menu"/>
                                <span
                                    className="hide-text-overflow"
                                    style={{
                                        ...dialogStyles.listItem,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '15px'
                                    }}
                                >
                                    <div
                                        style={{display: 'flex', gap: '5px', alignItems: 'center', marginLeft: '10px'}}>
                                       <ColorIndicator currentStatus={contact.currentStatus}/>
                                    </div>
                                    {`${firstName} ${lastName}`}
                                </span>
                            </button>
                        </li>
                    );
                })}
            </ul>

            <SilentModeSwitch
                checked={silentMode}
                onChange={handleInputChange}
                hint="silentModeForwardHint"
            />
            </div>


        </Modal>
    );
};

ForwardDialogModal.propTypes = {
    state: PropTypes.object,
    close: PropTypes.func,
    contactList: PropTypes.array,
    contactClick: PropTypes.func,
};

export default ForwardDialogModal;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/chat-components/ForwardDialogModal.jsx